// extracted by LIB_CSS_EXTRACT_LOADER
import "./textarea_module.css"
export default {"textarea":"textarea-hdUZWB"};